import request from "@/utils/request.js"

/*平台 - 用户*/
// 平台-用户管理列表
export const listSystemAdmin = (pageData, formData) => {
    return request.get(`/admin/systemAdmin/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 平台-用户管理-删除用户
export const removeAdmin = (id) => {
    return request.delete(`/admin/systemAdmin/${id}`)
}

// 平台-用户管理-新增用户
export const addSystemAdmin = (formData) => {
    return request.post(`/admin/systemAdmin`, formData)
}
// 平台-用户管理-角色（设置系统用户角色）
export const setSystemAdminRole = (id, formData) => {
    return request.put(`/admin/systemAdmin/role/${id}?roleId=${formData.roleId}`)
}
// 用户管理列表（用在：平台-营销-电子卡券记录/积分记录。查询操作人）
export const listOperatorAdmin = (pageData, formData) => {
    return request.get(`/admin/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

/*租户*/
// 租户列表
export const listTenant = (pageData, formData) => {
    return request.get(`/tenant/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 新增-租户
export const addTenant = (formData) => {
    return request.post('/tenant', formData)
}

// 修改-租户
export const editTenant = (formData) => {
    return request.put('/tenant', formData)
}

// 获取模版枚举类型
export const listTemplateType = (formData) => {
    return request.get(`/tenant/templateType?appType=${formData.appType}`)
}

// 租户详情
export const detailTenant = (id) => {
    return request.get(`/tenant/${id}`)
}

// 生成小程序码
export const getMinAppQRCode = (id) => {
    return request.put(`/tenant/appletReferralCode/${id}`)
}

/*角色*/
// 平台-角色列表
export const listRole = (pageData, formData) => {
    return request.get(`/role/systemRolePage/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
// 新增角色
export const addRole = (formData) => {
    return request.post('/role', formData)
}
// 删除角色
export const removeRole = (id) => {
    return request.delete(`/role/${id}`)
}
// 角色详情
export const detailRole = (id) => {
    return request.get(`/role/${id}`)
}
// 修改角色
export const editRole = (formData) => {
    return request.put(`/role/${formData.roleId}`, formData)
}

/*权限相关*/
// 所有菜单、权限
export const listMenuAll = (formData) => {
    return request.get(`/menu/all`, {params: formData})
}

/*设置 - 用户*/
// 设置-用户管理列表
export const listOrdinaryAdmin = (pageData, formData) => {
    return request.get(`/admin/ordinaryAdmin/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 设置-用户管理-删除用户
export const removeOrdinary = (id) => {
    return request.delete(`/admin/ordinaryAdmin/${id}`)
}

// 设置-用户管理-新增用户
export const addOrdinaryAdmin = (formData) => {
    return request.post(`/admin/ordinaryAdmin`, formData)
}
